// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dmmVr","toggle":"styles_toggle__1uvRG","preview":"styles_preview__2HTL6"};